module.exports = __webpack_public_path__ + "static/logo-716521c6f9a6951179ca2638200d98f7.png";